<!-- Breadcrumb -->
<app-campaign-breadcrumb
[stateAction]="this.stateAction"
[messageInstanceId]="this.messageInstanceId"
[campaignId]="this.campaignId"
[actionId]="this.actionId"
[actualStep]="this.actualStep"
[actionTypeCode]="actionTypeCode">
</app-campaign-breadcrumb>

<!-- Titolo -->
<div class="ui-g-12 campaign-step-title flex-align-center">
  <h2>{{ 'campaign.actionEmissionSetup' | translate }}</h2>
</div>
<!-- Form Date di Emissione -->
<section class="ui-g-12">
   <!-- Nome/ID -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="MessageInstanceDtoSchema">
      <div class="ui-g-12">
        <label [ngClass]="{'required': !MessageInstanceDtoSchema.name.nullable}">{{ MessageInstanceDtoSchema.name.keyName }}</label>
      </div>
      <div class="ui-g-12">
        <input type="text" pInputText [(ngModel)]="name" style="width: 50%;" maxlength="50">
        <span class="input-error-notification" *ngIf="invalidSubmit && !name">{{ 'campaign.nameValidator' | translate }}</span>
      </div>
    </div>
  <h3 class="section-title ui-g-12">
    {{ 'campaign.setEmissionDates' | translate }}
  </h3>
  <div
    class="ui-g-12"
    *ngIf="
      !showEmissionDatesForm &&
      emissionDatesForm &&
      calendarTranslateService &&
      calendarTranslateService.pcalendarTranslate &&
      setDefaultDateStart() &&
      setDefaultDateEnd()
    "
  >
    <p style="font-weight: 600;">
      {{ 'campaign.messageDistributionDates' | translate:{startDate: setDefaultDateStart(true), endDate: setDefaultDateEnd(true)} }}
      <a style="margin-left: 15px; cursor: pointer;" (click)="showEmissionDatesForm = true;">
        <i class="fa fa-pencil" aria-hidden="true"></i>
        <span>{{ 'common.edit' | translate }}</span>
      </a>
    </p>
  </div>
  <form *ngIf="emissionDatesForm && showEmissionDatesForm" [formGroup]="emissionDatesForm" [ngClass]="{'invalid-submit': invalidSubmit}">
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="startCampaignDate">
      <div class="ui-g-12 ui-md-4 emission-date-col">
        <label class="top-label required">{{ 'common.from' | translate }}</label>
        <app-kv-calendar
          #startDateField
          [inputName]="'startDate'"
          [formData]="emissionDatesForm"
          [startDateSelector]="true"
          [endDateInputName]="'endDate'"
          [minDate]="startCampaignDate"
          [maxDate]="emissionDatesForm.get('endDate').value || endCampaignDate"
          [endDateCalendar]="endDateField"
          [defaultDate]="emissionDatesForm.get('endDate').value || startCampaignDate"
          [defaultValue]="setStartDate()"
        ></app-kv-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && emissionDatesForm.controls['startDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-4 emission-date-col">
        <label class="top-label required">{{ 'common.to' | translate }}</label>
        <app-kv-calendar
          #endDateField
          [inputName]="'endDate'"
          [formData]="emissionDatesForm"
          [endDateSelector]="true"
          [startDateInputName]="'startDate'"
          [minDate]="emissionDatesForm.get('startDate').value || startCampaignDate"
          [maxDate]="endCampaignDate"
          [startDateCalendar]="startDateField"
          [defaultDate]="emissionDatesForm.get('startDate').value || startCampaignDate"
          [defaultValue]="setEndDate(endDateField)"
        ></app-kv-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && emissionDatesForm.controls['endDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-4" style="height: 0;">
        <button
          *ngIf="!actionId"
          pButton
          type="button"
          class="k-generic-btn"
          label="{{ 'campaign.saveEmissionDates' | translate }}"
          (click)="saveEmissionDates()">
        </button>
      </div>
    </div>
  </form>
</section>
<div *ngIf="actionId">
  <!-- Selezione Touchpoint Offline-->
  <section class="ui-g-12">
    <h3 class="section-title" *ngIf="actionTypeCode !== 'MSG'">{{ 'campaign.setTouchpointTitle' | translate }}</h3>
    <h3 class="section-title" *ngIf="actionTypeCode === 'MSG'">{{ 'campaign.setMSGTouchpointTitle' | translate }}</h3>
    <div class="ui-g-12 ui-md-3">
      <label>{{ 'campaign.touchpointOffline' | translate }}</label>
    </div>

    <div class="ui-g-12" [ngClass]="{'touchpoint-error': invalidSubmit && (!touchpointsOffline || touchpointsOffline.length === 0) && (!selectedTouchpoints || selectedTouchpoints.length === 0) && (!prioritiesOnline || prioritiesOnline.length === 0) }">
      <app-campaign-touchpoints
        [actionId]="actionId"
        [messageInstanceId]="messageInstanceId"
        [scope]="'emission'"
        [actionTypeCode]="actionTypeCode"
        [invalidSubmit]="invalidSubmit"
        [tpWithoutStores]="tpWithoutStores"
        (onTpSet)="setPriorities($event)"
        (tpSelected)="onTouchpointSelection($event)"
        (tpOnline)="setTouchpointOnline($event)"
        (tpSetOnline)="setPrioritiesOnline($event)">
      </app-campaign-touchpoints>
    </div>
    <div class="ui-g-12" *ngIf="invalidSubmit && (!touchpointsOffline || touchpointsOffline.length === 0) && (!selectedTouchpoints || selectedTouchpoints.length === 0) && (!prioritiesOnline || prioritiesOnline.length === 0)">
      <span class="input-error-notification">{{ 'campaign.touchpointValidator' | translate }}</span>
    </div>
  </section>
  <!-- Selezione Touchpoint Online e relative priorità -->
  <section class="ui-g-12" *ngIf="touchpointOnline">
    <div class="ui-g-12">
      <label>{{ 'campaign.touchpointOnline' | translate }}</label>
    </div>

    <div class="ui-g-12 ui-md-10"
    [ngClass]="{'touchpoint-error': invalidSubmit && (!prioritiesOnline || prioritiesOnline.length === 0) && (!selectedTouchpoints || selectedTouchpoints.length === 0) && (!touchpointsOffline || touchpointsOffline.length === 0)}">
      <app-campaign-drag-and-drop
        [channels]="touchpointOnline"
        [channelPriorities]="prioritiesOnline"
        [savedPriorities]="savedPriorities"
        (priorityListChanged)="priorityChangedHandler($event)">
      </app-campaign-drag-and-drop>
    </div>
    <div class="ui-g-12" *ngIf="invalidSubmit  && (!prioritiesOnline || prioritiesOnline.length === 0) && (!selectedTouchpoints || selectedTouchpoints.length === 0) && (!touchpointsOffline || touchpointsOffline.length === 0)">
      <span class="input-error-notification">{{ 'campaign.touchpointValidator' | translate }}</span>
    </div>
  </section>
  <!-- Selezione Clienti -->
  <section class="ui-g-12">
    <h3 class="section-title" *ngIf="actionTypeCode !== 'MSG'">{{ 'campaign.customersToDistribute' | translate }}</h3>
    <h3 class="section-title" *ngIf="actionTypeCode === 'MSG'">{{ 'campaign.customersToDistributeMSG' | translate }}</h3>
    <!-- Selezione Lista Clienti -->
    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-3">
        <label class="required">{{ 'campaign.chooseSavedCustomerList' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-3">
        <p-dropdown
          *ngIf="customerLists && customerLists.length > 0"
          [options]="customerLists"
          [style]="{'width':'100%'}"
          [(ngModel)]="selectedCustomerList">
        </p-dropdown>
        <span class="input-error-notification" *ngIf="invalidSubmit && !selectedCustomerList">{{ 'campaign.distributionListValidator' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-1"></div>
      <div class="ui-g-12 ui-md-5">
        <div class="campaign-button flex-align-center" (click)="openAddRecipientList()">
          <div class="campaign-button__label">
            {{ 'campaign.createRecipientList' | translate }}
          </div>
          <div class="text-right">
            <i class="fa fa-arrow-right icon-campaign-arrow"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-10 flex-align-center" >
      <div class="ui-g-12 ui-md-3">
        <label class="required">{{ 'campaign.itemCode' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-3">
        <p-autoComplete class="auto-complete"
        [(ngModel)]="selectedProductItem"
        [ngModelOptions]="{standalone: true}"
        [suggestions]="productItemList"
        (completeMethod)="filterByProductItem($event)"
        (onSelect)="getProductItemBarcode($event)"
        [minLength]="3"
        [dropdown]="true"
        [delay]="2000"
        [disabled]="flagDeploy === 'G'"
        (onClear)="clearProductItem()"
        field="label"
        >
      </p-autoComplete>
      <span class="input-error-notification" *ngIf="invalidSubmit && !itemCode">{{ 'campaign.itemCodeValidator' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-3">
        <label class="required">{{ 'promotion.barCode' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-3">
        <p-dropdown class="barcode"
          [(ngModel)]="barCode"
          [ngModelOptions]="{standalone: true}"
          [disabled]="!isProductItemPresent || (flagDeploy === 'P' && emissionDatesForm.get('endDate').value < today)"
          [options]="productItemBarcodeList"
          [style]="{'width':'100%'}"
          field="barcode"
        >
        </p-dropdown>
        <span class="input-error-notification" *ngIf="invalidSubmit && !itemCode">{{ 'campaign.barcodeValidator' | translate }}</span>
      </div>
    </div>
  </section>
  <!-- Save -->
  <section class="ui-g-12" style="padding-bottom: 150px;">
    <div class="ui-g-12 ui-md-10 text-right">
      <button
        pButton
        (click)="checkBarcodeAvailability()"
        type="button"
        class="k-generic-btn"
        label="{{ 'common.save' | translate }}">
      </button>
    </div>
  </section>
</div>
<!-- Dialog Lista Destinatari -->
<p-dialog
  class="campaign-dialog"
  [positionTop]="40"
  [positionLeft]="'50%'"
  [header]="dialogTitle"
  [width]="1000"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
  <app-new-coupon-recipient-list
    *ngIf="showAddRecipientList"
    (onSaveList)="setCustomerData($event); closeDialog();"
  >
  </app-new-coupon-recipient-list>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-emission-setup/coupon-emission-setup.component.html